import { useQuery } from "@tanstack/react-query";
import { ChatsQueryKeys } from "./chatsQueryKeys";
import { getChatContacts } from "@/api/chats";

export const useChatContacts = (enabled: boolean = true) => {
  return useQuery({
    queryKey: [ChatsQueryKeys.ChatContacts],
    queryFn: ({ signal }) => getChatContacts({ signal }),
    enabled,
  });
};
